import * as R from "ramda";

import { get } from "lodash";

export const isFetching = state =>
  state.event.event.fetching || !state.event.event.event.id;

export const eventDetails = state => state.event.event.event;

export const isEventError = state => state.event.event.eventError;

export const eventId = state => get(state.event, "event.event.id");
export const getOrgId = state => get(state.event, "event.event.org_id");
export const eventUUID = R.pathOr("", ["event", "event", "event", "uuid"]);
export const eventSlug = R.pathOr("", ["event", "event", "event", "slug"]);
export const getEventTimezone = R.path(["event", "event", "event", "timezone"]);
export const getEventCurrency = R.path(["event", "event", "event", "currency"]);
export const credentials = state =>
  get(eventDetails(state), "module_settings.credentials.credentials", []);
export const getEventScope = () => "live";
export const getEventTemplate = R.path(["event", "event", "event", "template"]);
export const getIsLightEvent = R.pathOr(false, [
  "event",
  "event",
  "event",
  "is_light"
]);
export const getIsHeadshotCompressionEnabled = R.pathOr(false, [
  "event",
  "event",
  "event",
  "enable_headshot_compression"
]);

export const isSpeakersEnabled = R.pathOr(false, [
  "event",
  "event",
  "event",
  "speaker_type_enabled"
]);

export const isSponsorsOrExhibitorsEnabled = state =>
  R.pathOr(false, ["event", "event", "event", "sponsor_type_enabled"])(state) ||
  R.pathOr(false, ["event", "event", "event", "exhibitor_type_enabled"])(state);

export const getExhibitorRecordTypeId = R.pathOr(false, [
  "event",
  "event",
  "event",
  "exhibitor_record_type_id"
]);
export const getSponsorRecordTypeId = R.pathOr(false, [
  "event",
  "event",
  "event",
  "sponsor_record_type_id"
]);
export const getSpeakerRecordTypeId = R.pathOr(false, [
  "event",
  "event",
  "event",
  "speaker_record_type_id"
]);

export const getExhibitorConfigSetId = R.pathOr(false, [
  "event",
  "event",
  "event",
  "exhibitor_config_set_id"
]);
export const getSponsorConfigSetId = R.pathOr(false, [
  "event",
  "event",
  "event",
  "sponsor_config_set_id"
]);
export const getSpeakerConfigSetId = R.pathOr(false, [
  "event",
  "event",
  "event",
  "speaker_config_set_id"
]);

export const isConferenceTemplate = state =>
  getEventTemplate(state) === "conference";
export const isVirtualEvent = state => getEventScope(state) === "virtual";
export const isHybridEvent = state => getEventScope(state) === "hybrid";
export const isLiveEvent = state => getEventScope(state) === "live";
export const isVirtualOrHybridEvent = state =>
  isHybridEvent(state) || isVirtualEvent(state);
export const isLiveOrHybridEvent = state =>
  isHybridEvent(state) || isLiveEvent(state);

export const isEventFeatureEnabled = state => feature => {
  return R.pathOr(
    [],
    ["event", "event", "event", "enabled_features"]
  )(state).includes(feature);
};

export const isOrgFeatureEnabled = state => feature => {
  return R.pathOr(
    [],
    ["event", "event", "event", "enabled_org_features"]
  )(state).includes(feature);
};

export const isIntegrationEnabled = state => integration => {
  return R.pathOr(false, [
    "event",
    "event",
    "event",
    "enabled_integrations",
    integration
  ])(state);
};

export const getIntegrationMappings = state => integration => {
  return R.pathOr(
    [],
    ["event", "event", "event", "integration_mappings", integration]
  )(state);
};

export const isTypeEnabled = state => type => {
  return (
    R.findIndex(t => t === type)(state.event.event.event.enabled_types) !== -1
  );
};

export const accountTypes = state =>
  get(eventDetails(state), "module_settings.accounts.types", []).sort(
    (a, b) => b.name.toLowerCase() - a.name.toLowerCase()
  );
export const eventHomeAccountRecordTypes = state =>
  get(state.event, "event.eventHomeAccountRecordTypes");

export const getBackgroundUrl = R.compose(
  url => `url(${url})`,
  R.pathOr("", ["event", "event", "event", "background_image_url"])
);
